import {rpAppLink} from "@pg-mono/rp-routes";

import {ArticleCategory, getSlugByArticleCategory} from "../actions/ArticleCategory";

export function getCategoryUrl(category: ArticleCategory) {
    return rpAppLink.article.category({categorySlug: getSlugByArticleCategory(category)});
}
